import React from 'react';

import { Row } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { Dropdown } from 'components/Forms';

interface IMessagingPanelFiltersProps {
  unread: string;
  handleFilter: any;
}

const MessagingPanelFilters = ({ unread, handleFilter }: IMessagingPanelFiltersProps) => {
  const intl = useIntl();

  const options: ISelectOption[] = [
    {
      value: '0',
      label: intl.formatMessage({ id: 'allMsgKey' })
    },
    {
      value: '1',
      label: intl.formatMessage({ id: 'unreadMessagesKey' })
    }
  ];

  return (
    <Row className="d-inline-flex m-2">
      <Dropdown
        variant="transparent"
        options={options}
        onChange={(option: ISelectOption) => handleFilter(option.value === '1' ? true : false)}
        value={options.find((option) => option.value === unread)}
        containerNoWrap
        isSearchable={false}
        fitContent
      />
    </Row>
  );
};

export default MessagingPanelFilters;
